import {
	GlobalEmailTemplateMetadata,
	GlobalEmailTemplate,
} from '@models/global-email-templates';

export class SelectEmailTemplate {
	static readonly type = '[Email Templates] Select Template';
	constructor(public templateId: string) {}
}

export class CreateEmailTemplate {
	static readonly type = '[Email Templates] Create Template';
	constructor(
		public template: GlobalEmailTemplateMetadata,
		public templateType: 'business' | 'global',
		public afterCreateAction?: (templateId: string) => void,
	) {}
}

export class UpdateEmailTemplate {
	static readonly type = '[Email Templates] Update Template';
	constructor(
		public templateId: string,
		public templateMetadata: Partial<GlobalEmailTemplateMetadata>,
		public templateVersion?: Omit<Partial<GlobalEmailTemplate>, 'id'>,
	) {}
}

export class DeleteEmailTemplate {
	static readonly type = '[Email Templates] Delete Template';
	constructor(public templateId: string) {}
}
